import "./Edit.css"
import ImageArea from "./edit components/ImageArea"
import Controls from "./edit components/Controls"
import ControlBtns from "./edit components/ControlBtns"
import html2canvas from "html2canvas";
import downloadIcon from "../assets/downloadIcon.png"
import React from "react";
import { useState } from "react";
import trueIcon from "../assets/true.png"
import { Link } from "react-router-dom";

const Edit = () => {
    const [loading,setLoading] = useState(false)

    const handleDownload = () => {
        const element = document.getElementById("outputImg");
        setTimeout(() => setLoading(true), 500);
        html2canvas(element, {
          scale: 4,
          useCORS: true
        }).then(canvas => {
          const fileName = "10 Days of CODE.png";
          canvas.toBlob(blob => {
            const file = new File([blob], fileName, { type: "image/png" });
            if (navigator.share && (navigator.platform === 'iPhone' || navigator.platform === 'iPad')) {
              navigator
                .share({
                  files: [file],
                  title: fileName,
                  text: "Save this image to your gallery",
                })
                .then(() => {
                    
                })
                .catch(() => {
                    
                });
            } else {
              const link = document.createElement("a");
              link.download = fileName;
              link.href = URL.createObjectURL(file);
              link.click();
            }
          });
        });
      };
      
      
      
      
      

    return(
        <div className="Edit">
            <h3>Thanks for your participation</h3>
            <ImageArea/>
            <h4>IMAGE SETTING</h4>
            <div className="controlArea">
                <ControlBtns/>
                <Controls/>
            </div>
            <div className="btnContain">
                <button onClick={handleDownload} id="downloadBtn">

                    {
                        loading ?<>Saved <img src={trueIcon} alt="" /></> : <>Download <img src={downloadIcon} alt="" /></>
                    }
                    
                    
                </button>
            </div>
            <div className="aboutLinkContainer">
                <Link to={"/about"} className="aboutLink">About our Team</Link>
            </div>
            
            
        </div>
    )
}

export default Edit